import React from "react";
import TextMessage from "./TextMessage";
import moment from "moment";
import DocuMessage from "./DocuMessage";
import ImageMessage from "./ImageMessage";
import VideoMessage from "./VideoMessage";
import RecordingMessage from "./RecordingMessage";
import VideoBubbleMessage from "./VideoBubbleMessage";

function MessageComponent({
  type,
  text,
  isMyMessage,
  createdAt,
  isLocalMessage,
  documentLink,
  mediaLink,
  bubbleLink,
  deletedCaption,
}) {
  const showInlineDeleted = Boolean(
    deletedCaption && type !== "image"
  );

  function getMessageElementForType() {
    switch (type) {
      case "message":
        return <TextMessage text={text} />;
      case "document":
        return <DocuMessage text={text} documentLink={documentLink} />;
      case "image":
        return (
          <ImageMessage
            src={mediaLink}
            alt="image"
            deletedCaption={deletedCaption}
          />
        );
      case "video":
        return <VideoMessage src={mediaLink} />;
      case "recording":
        return <RecordingMessage src={mediaLink} />;
      case "videoBubble":
        return (
          <VideoBubbleMessage src={mediaLink} bubbleSrc={bubbleLink || mediaLink} />
        );
      default:
        return <TextMessage text={text} />;
    }
  }

  return (
    <div className={`d-flex align-items-end flex-column  mb-3`}>
      <div
        className={`message-base shadow-sm  ${
          isMyMessage
            ? "my-message-border-radius"
            : "message-border-radius"
        } animate__animated ${
          !isLocalMessage && "animate__zoomI"
        } animate__faster `}
        style={{ backgroundColor: isMyMessage ? "#D8F7FF" : "white" }}
      >
        {getMessageElementForType()}
        {showInlineDeleted && (
          <div
            className={`message-deleted-inline ${isMyMessage ? "text-end" : ""}`}
          >
            {deletedCaption}
          </div>
        )}
      </div>
      <div className="text-gray-500 message-time text-right font-semibold font-6 mb-1 animate__animated animate__fadeIn">
        {moment(createdAt).format("LT")}
      </div>
    </div>
  );
}

export default MessageComponent;
